import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class BoardContext extends HasProjectMixin(Model) {
  declare id: number;
  declare board: number;
  declare websiteUrl: string | null;
  declare businessDescription: string | null;
  declare privateDocument: number | null;
  declare selectedUrls: string[];
  declare draftQuestions: { questions: DraftQuestion[] } | null;
  declare contextHealth: string | null;
  declare status: "in_progress" | "completed";
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "BoardContext";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "websiteUrl", dataSource: "website_url" },
      { name: "businessDescription", dataSource: "business_description" },
      { name: "privateDocument", dataSource: "private_document", type: "number" },
      { name: "selectedUrls", dataSource: "selected_urls", defaultValue: [] },
      { name: "draftQuestions", dataSource: "draft_questions", defaultValue: null },
      { name: "contextHealth", dataSource: "context_health" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "status", dataSource: "status" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }
}

export interface DraftQuestion {
  text: string;
  question_type: "single_select" | "multi_select";
  options: string[];
  answer?: string[];
}

// @ts-expect-error - exposeProperties is internal method
BoardContext.exposeProperties();
